export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "collapse_sidebar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réduire le menu"])},
        "expand_sidebar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déployer le menu"])}
      },
      "en": {
        "collapse_sidebar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Collapse menu"])},
        "expand_sidebar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Expand menu"])}
      }
    }
  })
}
